// Colored initials for environments (e.g. "Local Mock" → "Lo"), used in the
// Environments modal sidebar and editor header.

const AVATAR_COLORS = [
  '#0d9488', // teal
  '#2563eb', // blue
  '#7c3aed', // violet
  '#db2777', // pink
  '#d97706', // amber
  '#dc2626', // red
  '#059669', // emerald
  '#0891b2', // cyan
  '#4f46e5', // indigo
  '#c026d3', // fuchsia
];

/** First two characters of the name, first uppercased (e.g. "Local Mock" → "Lo"). */
export function envInitials(name) {
  const trimmed = (name || '').trim();
  if (!trimmed) return '?';
  const first = trimmed[0].toUpperCase();
  const second = trimmed[1] ? trimmed[1].toLowerCase() : '';
  return first + second;
}

/** Deterministic color for a name so the same environment always looks the same. */
export function envColor(name) {
  const str = name || '';
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}
